(async()=>{
    const {loadScript: e, loadStyle: t} = await import(window.theme.modules.utils);
    var a = await import(window.theme.modules.baseComponent);
    customElements.define("video-player", class extends a.default {
        elements = {
            player: "[data-player]",
            HTMLPlayer: "video"
        };
        async onIntersect(e) {
            e && !this.player && await this._initPlayer()
            // !e && this.player && this.player.playing && this.player.pause()
        }
        async _initPlayer() {
             t("https://cdn.plyr.io/3.6.8/plyr.css");
             if(this.hasAttribute("internal")){
             window.Plyr || await e(window.theme.scripts.Plyr),
             this.player = new window.Plyr(this.hasAttribute("internal") ? this.$HTMLPlayer : this.$player)
             }
        }
    }
    )
}
)();
